import React from "react";
import { Route } from "react-router-dom";
import { motion } from "framer-motion";
import { useMutation } from "@apollo/react-hooks";
import dateFormat from "dateformat";
import uniqid from "uniqid";

import Layout from "./Layout";
import { Redirect } from "react-router-dom";
import { isLoggedIn, getUser, deleteUser } from "./../lib/session";
import { TRACK_ACTIVITY } from "./../lib/graphql/mutations";
import motionConfig from "./../config/motion.json";
import routeList from "./../config/routeList.json";

const PageContainer = () => {
  const [trackActivity] = useMutation(TRACK_ACTIVITY);
  const user = getUser();
  const { home = "/children_teens" } = user || {};

  const track = async (
    action,
    value,
    callback = () => {},
    errorCallback = () => {}
  ) => {
    try {
      const now = new Date();
      const mutationId = uniqid();
      const response = await trackActivity({
        variables: {
          action,
          actionDate: dateFormat(now, "yyyy-mm-dd HH:MM:ss"),
          actionValue: value,
          mutationId
        },
        errorPolicy: "all"
      });
      callback(response);
    } catch (error) {
      errorCallback(error);
    }
  };

  const logout = async () => {
    return track(
      "logout",
      "user-logout",
      () => {
        deleteUser();
        window.location.reload();
      },
      () => {
        deleteUser();
        window.location.reload();
      }
    );
  };

  return routeList.map(route => {
    return (
      <Route
        exact
        path={route.path}
        key={route.path}
        render={props => {
          if (route.type === "private" && !isLoggedIn()) {
            return <Redirect to="/" />;
          } else if (
            (route.type === "login" || route.type === "register") &&
            isLoggedIn()
          ) {
            return <Redirect to={home} />;
          }
          const Component = require(`./_templates/${route.component}`).default;
          return (
            <Layout routeList={routeList} {...route}>
              <div className="app">
                <motion.div {...motionConfig.page}>
                  <Component
                    {...props}
                    {...route}
                    track={track}
                    logout={logout}
                  />
                </motion.div>
              </div>
            </Layout>
          );
        }}
      />
    );
  });
};

export default PageContainer;
